module.exports = {
      id: "list-open-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#list-open",
      toString: function () {
        return this.url;
      }
    }